
<h4>Leadership Content</h4><br><br>
<div class="select-access-level">Access Level:</div>
<div class="input-type-select-access-level" [(accessLevel)]="section.accessLevel"></div><br><br>
<div class="select-padding-top">Padding Top</div>
<input type="text" placeholder="Enter an integer" [(ngModel)]="section.contentPaddingTop"><br>
<div class="select-padding-bottom">Padding Bottom</div>
<input type="text" placeholder="Enter an integer" [(ngModel)]="section.contentPaddingBottom"><br><br>